// extracted by mini-css-extract-plugin
export default {"body":"body-TqZPpiUd","priceLabel":"priceLabel-_i4e73Y2","coinIcon":"coinIcon-OopZpZCc"};